import styled from 'styled-components';

export const Title = styled.span`
  font-size: 26px;

  &:before {
    font-family: 'telusdings';
    padding-right: 10px; 
    content: "\\E057";
  }
`;

export default { Title };
